export function escapeHtml(value: string): string {
  return value.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;");
}

/** For a value going inside double quotes, as in `name="value"`. */
export function escapeHtmlAttribute(value: string): string {
  return escapeHtml(value).replaceAll('"', "&quot;");
}

/** For a value going inside single quotes, as JSON attributes do. */
export function escapeSingleQuotedHtmlAttribute(value: string): string {
  return escapeHtml(value).replaceAll("'", "&#39;");
}

export function highlightSimpleHtml(code: string): string {
  return escapeHtml(code)
    .split(/(&lt;!--.*?--&gt;)/g)
    .map((part) => {
      if (part.startsWith("&lt;!--") && part.endsWith("--&gt;")) {
        return `<span class="text-500">${part}</span>`;
      }

      return part
        .replaceAll(
          /([a-zA-Z-]+)=("[^"]*")/g,
          '<span class="text-700">$1</span>=<span class="text-900">$2</span>'
        )
        .replaceAll(/(&lt;\/?)([a-zA-Z0-9-]+)/g, '$1<span class="text-primary">$2</span>');
    })
    .join("");
}
